angular.module('aq.filters.tools')
.filter("replace", function() {
    return function(input, value) {
        var result = value.split(",");
        return (input || '').replace(result[0], result[1]);
    }
});